import axios from 'axios'

export default {
  computed: {
    GO_CATALOG_HOST() {
      return `${this.$config.goCatalogApiURL}/api/v1`
    },
    GET_MOCKUP_ENDPOINT() {
      const { GO_CATALOG_HOST } = this
      return `${GO_CATALOG_HOST}/mockup`
    },
  },
  methods: {
    getMockup({ mockups, store }) {
      const { GET_MOCKUP_ENDPOINT } = this
      const query = mockups.length
        ? `store=${store}&mockups[]=${mockups.join('&mockups[]=')}`
        : ''

      return axios
        .get(`${GET_MOCKUP_ENDPOINT}/empty?${query}`)
        .then((response) => response.data)
    },
  },
}
